var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._v("\n\n    Marketing - Coming Soon\n    "),_c('hr'),(_vm.ShowDashboard)?_c('div',{staticClass:"row"}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }